const cache = new Map()

export default {
  has (key) {
    return cache.has(key)
  },

  set (key, value, duration = 1) {
    setTimeout(() => {
      cache.delete(key)
    }, duration * 1000)
    return cache.set(key, value)
  },

  get (key) {
    return cache.get(key)
  },

  delete (key) {
    return cache.delete(key)
  },

  clear () {
    return cache.clear()
  }
}



// WEBPACK FOOTER //
// ./src/commons/cache.js